import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=52fa4cbc&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=js&"
export * from "./MySettings.vue?vue&type=script&lang=js&"
import style0 from "./MySettings.vue?vue&type=style&index=0&id=52fa4cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fa4cbc",
  null
  
)

export default component.exports